import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginComponent from './login.component';
import './login.scss';

export default
  angular.module('components.login', [
    uiRouter
  ])
    .component('login', loginComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('login', {
          parent: 'auth',
          url: '/login',
          component: 'login'
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/auth/login/login.module.js